module.exports = __webpack_public_path__ + "static/media/2.f5b7826f.svg";